// 新协议
function kkmhhybrid_show_tips (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "show_tips",
    },
    param: {
      text: opt.text,
      time: opt.time,
      style: opt.style,
      type: opt.type || 1
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}
// 旧协议
function kkaction_showToast (opt) {
  hybrid({
    hybridParam: {
        schema: "kkaction",
        tagname: "showToast",
    },
    param: {
      text: opt.text,
      time: opt.time + '', // 安卓这个要传字符串不然客户端会闪退
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}

/**
 * 展示提示<br>
 * kkmhhybrid://show_tips{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=94012145}<br>
 * kkaction://showToast<br>
 * @param {Object} opt 参数对象
 * @param {String} opt.text 提示文案
 * @param {Number} opt.time 提示时长 长为4s传1，短为2秒传0
 * @param {Number} opt.style 展示的样式 style=1 默认类型 style=2 比心动画
 * @param {Number} opt.type 控制toast的显示层级默认逻辑：1；2：toast的显示层级最高(切换页面也需要展示) 2020-01-06 新增字段。备注: 和其他页面toast冲突是需要队列展示
 * @param {Function} opt.callback 回调函数
 */
function show_tips (opt, criticalAppVersion) {
  if(!criticalAppVersion) {
    criticalAppVersion = window.kkBaseInfo.criticalAppVersion;
  }
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if(!allow) {
    // 调用旧协议
    kkaction_showToast(opt);
  } else {
    // 调用新协议
    kkmhhybrid_show_tips(opt);
  }
}

export default show_tips;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/show_tips/index.js